<template lang="pug">
el-row
  el-col(:sm="24")
    el-table(style="width:100%", :data="rawDataArr")
      el-table-column(prop="x", label="Дата", :formatter="dateFormatter")
      el-table-column(v-for="k in dataKeys", :prop="k", :label="dataInfo[k].name", :formatter="priceFormatter", :key="k")
        template(slot-scope="scope")
          span(:style="{color: dataInfo[k].color}") {{ priceFormatter(scope.row, scope.column) }}
      el-table-column(label="Разлика", width="200")
        template(slot-scope="scope")
          span() {{ totalFormatter(scope.row) }}
</template>

<script>
import * as dateUtil from '../lib/dateUtil'

export default {
  props: {
    rawData: {default: false},
    tickFormat: {default: 'YYYY-MM-DD'},
    dataInfo: {},
    dataKeys: {}
  },
  computed: {
    rawDataArr () {
      if (!this.rawData || this.rawData.length == 0) {
        return []
      }
      const arr = []
      const keys = Object.keys(this.rawData)
      this.rawData['1_1'].forEach((x, i) => {
        const o = {}
        keys.forEach(k => o[k] = this.rawData[k][i])
        arr.push(o)
      })
      return arr
    }
  },
  methods: {
    dateFormatter (row, column) {
      const date = new Date(row[column.property])
      return dateUtil.format(date, this.tickFormat)
    },
    priceFormatter (row, column) {
      return this.common.formatPrice(Math.abs(row[column.property]), true)
    },
    totalFormatter (row) {
      return this.common.formatPrice(row['1_1'] + row['1_2'] + row['1_3'] - row['2_1'] - row['2_2'] - row['2_3'], true)
    },
  },
  watch: {
    rawData () {

    }
  }
}
</script>